export default "__VITE_ASSET__zw03abpR__"